import clsx from 'clsx';
import { MouseEventHandler, forwardRef } from 'react';
import { Icon, IconType } from 'atoms/Icon';
import { LoadingIcon } from 'atoms/LoadingIcon';
import { Span } from 'atoms/Typography';
import { DivRef } from 'pages/ProductListing/types';
import { useTranslations } from 'modules/i18n/useTranslations';
import styles from './styles.module.css';

export const LoadMore = forwardRef<
  DivRef,
  {
    loadMore?: (pageY: number) => void;
    text?: string;
    className?: string;
    isPrev?: boolean;
    isLoading?: boolean;
    onClick?: () => void;
  }
>(({ loadMore, isPrev, isLoading, text, className, onClick }, ref) => {
  const t = useTranslations();

  if (isLoading) {
    return (
      <LoadingIcon
        classes={{ root: className }}
        text={t('common.buttons.load-more.loading')}
      />
    );
  }

  const handleClick: MouseEventHandler = (e) => {
    loadMore?.(e.pageY);
    onClick?.();
  };

  return (
    <div
      ref={ref}
      className={clsx(styles.root, className)}
      onClick={handleClick}
    >
      <Icon
        className={clsx(styles.icon, isPrev && styles.prevIcon)}
        type={IconType.arrowLongDown}
      />
      <Span className={styles.text}>
        {text || t('common.buttons.load-more.text')}
      </Span>
    </div>
  );
});
